module.exports = __webpack_public_path__ + "img/photo-2-1.1d60d517.jpg";